import * as actions from '../constants/device_action_types.jsx';
import * as api from '../constants/devices_api.jsx';
import { authenticationService } from '../services/authenticationService';
import { request_helper} from "./request_helper.js";

export const actionDevices = {
    getDevices: (filter) => async (dispatch, getState) => {
        dispatch({ type: actions.START_REQUEST });
        const url = api.GET_DEVICES_LIST_API;
        let postData = {
            pageNumber: filter.pagesFilter.currentPage,
            modelFilter: {},
            sortFilter: {}
        }
        try {
            const data = await request_helper.callWithDispatch(dispatch, "POST", url, postData);
            let devices = {
                items: data.items,
                filter: { pagesFilter: { currentPage: data.currentPage, pageCount: data.pagesCount, maxItemsOnPage: data.maxItemsOnPage } }
            }
            dispatch({ type: actions.GET_DEVICES, devices });
        } catch (error) {
            return;
        }
    },
    getDevice: (deviceImei) => async (dispatch, getState) => {
        const url = api.GET_DEVICE_API + "?deviceImei=" + deviceImei;

        try {
            const data = await request_helper.callWithDispatch(dispatch, "GET", url);
            return data;
        } catch (error) {
            return null;
        }
    },
    addDevice: (device, ownProps) => async (dispatch, getState) => {
        const url = api.ADD_DEVICE_API;
        try {
            device = await request_helper.callWithDispatch(dispatch, "POST", url, device);
            dispatch({ type: actions.ADD_DEVICE, device });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    },
    editDevice: (device, ownProps) => async (dispatch, getState) => {
        const url = api.EDIT_DEVICE_API;
        try {
            device = await request_helper.callWithDispatch(dispatch, "POST", url, device);
            dispatch({ type: actions.EDIT_DEVICE, device });
            ownProps.history.goBack();
        } catch (error) {
            return;
        }
    }
};
